import { Box, SxProps, Theme } from "@mui/material";
import { isNil } from "lodash-es";

import { useCurrentCurrency } from "@/common/hooks/useCurrentCurrency";
import { CurrencyCode, GeneralCurrencyDto, GeneralCurrencyInputDto } from "@/core/api/generated/v1";

import InlineApiEnumValue from "../../Enum/InlineApiEnumValue";
import AppTypography, { AppTypographyProps } from "../../Text/AppTypography";

interface Props {
  value?: number | null;
  currency?: GeneralCurrencyDto | GeneralCurrencyInputDto | null;
  currencyCode?: CurrencyCode | null;
  typographyProps?: Partial<AppTypographyProps>;
  sx?: SxProps<Theme>;
}

/** Displays number value in some currency. E.g. 10 USD.
 *  By default (if currency not provided) checks for currency info in profile settings.
 */
export default function CurrencyValue({
  sx,
  value,
  currency,
  currencyCode,
  typographyProps,
}: Props) {
  const currentCurrency = useCurrentCurrency();
  const _currencyCode = currency?.code || currencyCode || currentCurrency?.code;

  return (
    <Box
      component='span'
      // direction='row'
      // spacing={0}
      // sx={{ display: "inline-flex", alignItems: "center", ...sx }}
      sx={{ whiteSpace: "nowrap", ...sx }}
    >
      {isNil(value) ? "-" : <Box component='span'>{value}</Box>}
      <Box component='span'>&nbsp;</Box>
      {!isNil(value) && (
        <AppTypography
          component='span'
          variant='caption'
          color='text.secondary'
          sx={{ textDecoration: "none" }}
          {...typographyProps}
        >
          {currency?.code ||
            (currencyCode && <InlineApiEnumValue type='CurrencyCode' value={currencyCode} />) || (
              <InlineApiEnumValue type='CurrencyCode' value={_currencyCode} />
            )}
        </AppTypography>
      )}
    </Box>
  );
}
